import PuzzleCreate from './views/PuzzleCreate.vue';
import PuzzleEdit from './views/PuzzleEdit.vue';
import PuzzleList from './views/PuzzleList.vue';
import PuzzleTemplateList from './views/PuzzleTemplateList.vue';
import Puzzle from './Root.vue';
import PuzzleTemplateCreate from './views/PuzzleTemplateCreate.vue';
import PuzzleTemplateEdit from './views/PuzzleTemplateEdit.vue';

export default {
  path: 'jogo/',
  component: Puzzle,
  name: 'admin-puzzle',
  redirect: '/jogo/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-crossword-list',
      component: PuzzleList,
    },
    {
      path: 'novo/',
      name: 'admin-crossword-new',
      component: PuzzleCreate,
    },
    {
      path: 'template/lista/:page',
      name: 'admin-crossword-template-list',
      component: PuzzleTemplateList,
    },
    {
      path: 'template/novo/',
      name: 'admin-crossword-template-new',
      component: PuzzleTemplateCreate,
    },
    {
      path: 'template/:puzzleId',
      name: 'admin-crossword-template-edit',
      component: PuzzleTemplateEdit,
    },
    {
      path: ':puzzleId',
      name: 'admin-puzzle-edit',
      component: PuzzleEdit,
    },
  ],
};
